import { render, staticRenderFns } from "./cetakbilyetdeposito.vue?vue&type=template&id=2c4addaf&scoped=true&"
import script from "./cetakbilyetdeposito.vue?vue&type=script&lang=js&"
export * from "./cetakbilyetdeposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4addaf",
  null
  
)

export default component.exports